/* add is-loaded class to body once DOM is ready */
const isLoaded = (): void => {
  document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('is-loaded');
  });
};

isLoaded();
